import { useContext } from 'react';

import FeatureFlagDetailsContext from '#helper/launchdarkly/feature-flag-details-context';

// Read-only, keyed by flag key: { [flagKey]: { value, variationIndex } }.
// variationIndex is null when LaunchDarkly hasn't served a real variation yet.
const useFeatureFlagDetails = () => useContext(FeatureFlagDetailsContext);

export default useFeatureFlagDetails;
